import { lazy } from 'react';

import withSuspenseIntersectionObserver from './withSuspenseIntersectionObserver';


const LazyHighchart = lazy(
    () => import(/* webpackChunkName: "highchart" */'./Highchart'),
);

export default withSuspenseIntersectionObserver(LazyHighchart);